import { render } from "./GamePoints.vue?vue&type=template&id=2afccc5a"
import script from "./GamePoints.vue?vue&type=script&lang=js"
export * from "./GamePoints.vue?vue&type=script&lang=js"

import "./GamePoints.vue?vue&type=style&index=0&id=2afccc5a&lang=scss"

import exportComponent from "/builds/chatplace/app-gamification/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__